// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".media-player-wrapper[data-v-0bcc6852]{height:100%;margin:0 auto;min-width:19rem;overflow:hidden;position:relative}.media-player-wrapper iframe[data-v-0bcc6852]{border:0;border-radius:0;bottom:0;box-shadow:none;height:100%;left:0;position:absolute;right:0;top:0;width:100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
